import {CANDIDATE_PROFILE, CLIENT_PROFILE} from '/enum/recordType.enum';

/**
 * Generates callback to display people's profile when tile inside the report screen is pressed
 *
 * @param {object} params - Parameters
 * @param {function} params.recordsShowRecord - A callback to show record
 *
 * @returns {function} Callback - A function to be called when item is pressed
 */
import {ReportProps} from '../Report.types';

export function generateOnRecordPress({
  recordsShowRecord = () => {},
}: ReportProps) {
  return ({id}: any) => {
    recordsShowRecord({
      //Candidates have prospectInfoId instead of id as clients
      recordType: isNaN(id) ? CANDIDATE_PROFILE : CLIENT_PROFILE,
      recordId: id,
    });
  };
}
